<div class="chats-list-toggle-button open" (click)="toggleChat()">
  <nz-badge [nzCount]="unreadCount$ | async" [nzStandalone]="true"></nz-badge>
  @if (!showChatsPanel) {
    <mat-icon>chevron_left</mat-icon>
  }
</div>

<nz-drawer
  [nzClosable]="false"
  [nzVisible]="showChatsPanel"
  [nzPlacement]="'right'"
  [nzWidth]="'100vw'"
  [nzWrapClassName]="'mobile-support-chat-drawer mobile-support-chat-list-drawer'"
  [nzZIndex]="1100"
  (nzOnClose)="toggleChat()"
  [nzBodyStyle]="{
    padding: '0',
  }"
  [nzMask]="true"
  [nzMaskClosable]="true">
  <ng-container *nzDrawerContent>
    <div class="chats-list-wrapper">
      <div class="chats-inner-wrapper">
        <div class="support-chat">
          <app-support-chat-mobile
            (openSupportChatEventEmitter)="toggleChatWindow()"
            (closeSupportChatEventEmitter)="toggleChat()"
            (searchTypeChange)="onSearchTypeChange($event)">
          </app-support-chat-mobile>
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>

<nz-drawer
  [nzClosable]="false"
  [nzVisible]="showChatsPanelWindow"
  [nzPlacement]="'right'"
  [nzWidth]="'100vw'"
  [nzWrapClassName]="'mobile-support-chat-drawer mobile-support-chat-window-drawer'"
  (nzOnClose)="toggleChatWindow()"
  [nzBodyStyle]="{
    padding: '0',
  }"
  [nzMask]="true"
  [nzMaskClosable]="true"
  [nzZIndex]="1101">
  <ng-container *nzDrawerContent>
    @if (openSupportChat$ | async) {
      <app-support-chat-window-mobile
        [searchType]="currentSearchType"
        (openSupportChatEventEmitter)="toggleChatWindow($event)">
      </app-support-chat-window-mobile>
    }
  </ng-container>
</nz-drawer>
